module.exports = __webpack_public_path__ + "assets/img/icon-live.webp?7b08dd839c6fa4ff04d0c66dccf01b25";